<template lang="pug">
  #treemap
    v-container(fluid)
      v-layout(row, wrap)
        v-flex(xs12)
          v-layout(column, wrap, align-center)
            p.mb-5 TIPOS DE AGRESIONES POR ESTADO
            #tree
              svg
</template>

<script>
import * as d3 from "d3";

export default {
  name: "Treemap",
  //props: {
  //},
  data() {
    return {
      stateColors: this.$store.state.stateColors,
      aggressionsTypes: this.$store.state.aggressionsTypes,
      labels: [],
      dataset: {},
      reports: this.$store.state.reports,
    };
  },
  watch: {
    "$store.state.reports": function (val) {
      this.dataset = {};

      this.dataset.name = "aggressionsTypes";
      this.dataset.children = [];
      this.aggressionsTypes.forEach((type) => {
        let states = [];
        this.stateColors.forEach((state) => {
          const reports = val.filter((report) => {
            if (
              state.name === "Ciudad de México" &&
              report.state === "CDMX" &&
              report.type === type.title
            ) {
              return true;
            }
            return (
              state.name.trim() === report.state && type.title === report.type
            );
          });
          states.push({
            name: state.alias,
            size: reports.length,
          });
        });
        this.dataset.children.push({
          name: type.title,
          children: states,
        });
      });

      // console.log(this.dataset);

      this.drawTreemap();
    },
  },
  /*computed: {
    reports: function () {
      return this.$store.state.reports;
    }
  }*/
  methods: {
    drawTreemap() {
      d3.select("#tree").selectAll("svg").remove();
      const svg = d3
        .select("#tree")
        .append("svg")
        .attr("width", 475)
        .attr("height", 570);
      //const svg = d3.select("#treemap svg");
      const width = +svg.attr("width");
      const height = +svg.attr("height");

      const fader = function (color) {
        return d3.interpolateRgb(color, "#fff")(0.2);
      };
      const color = d3.scaleOrdinal(d3.schemeBlues[9].map(fader));
      const format = d3.format(",d");

      const treemap = d3
        .treemap()
        .tile(d3.treemapResquarify)
        .size([width, height])
        .round(true)
        .paddingInner(1);

      const data = this.dataset;

      const root = d3
        .hierarchy(data)
        .eachBefore(function (d) {
          d.data.id = (d.parent ? d.parent.data.id + "." : "") + d.data.name;
        })
        .sum(sumBySize)
        .sort(function (a, b) {
          return b.height - a.height || b.value - a.value;
        });

      treemap(root);

      const cell = svg
        .selectAll("g")
        .data(root.leaves())
        .enter()
        .append("g")
        .attr("transform", function (d) {
          return "translate(" + d.x0 + "," + d.y0 + ")";
        });

      cell
        .append("rect")
        .attr("id", function (d) {
          return d.data.id;
        })
        .attr("width", function (d) {
          return d.x1 - d.x0;
        })
        .attr("height", function (d) {
          return d.y1 - d.y0;
        })
        .attr(
          "fill",
          (d) =>
            this.aggressionsTypes.filter(
              (type) => type.title === d.parent.data.name
            )[0].color
        )
        .style("stroke", "white");

      cell
        .append("clipPath")
        .attr("id", function (d) {
          return "clip-" + d.data.id;
        })
        .append("use")
        .attr("xlink:href", function (d) {
          return "#" + d.data.id;
        });

      cell
        .append("text")
        .attr("clip-path", function (d) {
          return "url(#clip-" + d.data.id + ")";
        })
        .selectAll("tspan")
        .data(function (d) {
          return [d.data.size, d.data.name];
        })
        .enter()
        .append("tspan")
        .attr("x", 4)
        .attr("y", function (d, i) {
          return 13 + i * 13;
        })
        .text(function (d) {
          return d;
        })
        .style("fill", "white")
        .style("font", "bold 14px Rajdhani, sans-serif");

      cell.append("title").text(function (d) {
        return d.data.id + "\n" + format(d.value);
      });

      d3.selectAll("input")
        .data([sumBySize, sumByCount], function (d) {
          return d ? d.name : this.value;
        })
        .on("change", changed);

      const timeout = d3.timeout(function () {
        d3.select('input[value="sumByCount"]')
          .property("checked", true)
          .dispatch("change");
      }, 2000);

      function changed(sum) {
        timeout.stop();

        treemap(root.sum(sum));

        cell
          .transition()
          .duration(750)
          .attr("transform", function (d) {
            return "translate(" + d.x0 + "," + d.y0 + ")";
          })
          .select("rect")
          .attr("width", function (d) {
            return d.x1 - d.x0;
          })
          .attr("height", function (d) {
            return d.y1 - d.y0;
          });
      }

      function sumByCount(d) {
        return d.children ? 0 : 1;
      }

      function sumBySize(d) {
        return d.size;
      }
    },
  },
  mounted() {
    this.dataset.name = "aggressionsTypes";
    this.dataset.children = [];
    this.aggressionsTypes.forEach((type) => {
      let states = [];
      this.stateColors.forEach((state) => {
        const reports = this.reports.filter((report) => {
          if (
            state.name === "Ciudad de México" &&
            report.state === "CDMX" &&
            report.type === type.title
          ) {
            return true;
          }
          return (
            state.name.trim() === report.state && type.title === report.type
          );
        });
        states.push({
          name: state.alias,
          size: reports.length,
        });
      });
      this.dataset.children.push({
        name: type.title,
        children: states,
      });
    });

    // console.log(this.dataset);

    this.drawTreemap();
  },
};
</script>

<style scoped lang="scss">
#treemap {
  p {
    font-family: "Rajdhani", sans-serif;
    color: white;
    font-size: 30px;
    font-weight: 700;
  }
}
</style>
